import { render, staticRenderFns } from "./dmsSms.vue?vue&type=template&id=10e1208f"
import script from "./dmsSms.ts?vue&type=script&lang=js&external"
export * from "./dmsSms.ts?vue&type=script&lang=js&external"
import style0 from "./dmsSms.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports